export default (value: string | undefined): string => {
    if (typeof(value) === "string") {
        let result = value;

        if ((result.match(/\*/g) || []).length > 1) {
            result = result.replace(/\*([^*]+?)\*/g, "<em>$1</em>");
        }

        if ((result.match(/_/g) || []).length > 1) {
            result = result.replace(/_([^_]+?)_/g, "<i>$1</i>");
        }

        return result;
    }
    else {
        return "";
    }
};
